import React from 'react';
import { Grid, Paper, Typography, Container, Box, useTheme } from '@mui/material';
import ProgramShowcase from '../ProgramShowcase';

const programsData = [
  {
    id: 1,
    level: 'Level 1',
    stroke: 'Freestyle',
    description: 'Introduction to basic water skills and learning freestyle techniques.',
  },
  {
    id: 2,
    level: 'Level 2',
    stroke: 'Backstroke',
    description: 'Introduction to backstroke, with focus on body position and kicking.',
  },
  {
    id: 3,
    level: 'Level 3',
    stroke: 'Breaststroke',
    description: 'Learning the technique for breaststroke, including arm movement and breathing.',
  },
  {
    id: 4,
    level: 'Level 4',
    stroke: 'Butterfly',
    description: 'Introduction to butterfly stroke with focus on timing and coordination.',
  },
  {
    id: 5,
    level: 'Semi-Squad',
    stroke: 'Advanced Techniques',
    description: 'Pre-squad level for refining all strokes and learning advanced techniques.',
  },
  {
    id: 6,
    level: 'Squad',
    stroke: 'Competitive Training',
    description: 'High-level training for all strokes, focusing on endurance, speed, and competition preparation.',
  },
];

const Programs = () => {
  const theme = useTheme();
  const oppocolor = theme.palette.mode === 'dark' ? theme.palette.primary.light :theme.palette.primary.dark;

  return (
    <Container sx={{ mt: 4, mb:4 }}>
      <Box sx={{ textAlign: 'center', mb: 4 }}>
      <Typography variant="h1" gutterBottom sx={{ color: theme.palette.primary.main }}> {/* Title Color */}
          Our Programs
        </Typography>
        <Typography variant="body1" sx={{ color: theme.palette.primary.main }}>
          We offer various levels to suit swimmers of all abilities.
        </Typography>
      </Box>

      <Grid container spacing={4}>
        {programsData.map((program) => (
          <Grid item xs={12} sm={6} md={4} key={program.id}>
            <Paper elevation={3} sx={{ p: 2, textAlign: 'center', borderRadius: 3 , backgroundColor: oppocolor}}>
              <Typography variant="h4" gutterBottom sx={{ color: theme.palette.background.default }}>
                {program.level}
              </Typography>
              <Typography variant="h6" gutterBottom sx={{ color: theme.palette.background.default }}>
                {program.stroke}
              </Typography>
              <Typography variant="body2" sx={{ color: theme.palette.background.default }}>
                {program.description}
              </Typography>
            </Paper>
          </Grid>
        ))}
      </Grid>
        
      
      <Box sx={{ textAlign: 'center', mb: 4, pt:4 }}>
        <Typography variant="h4" gutterBottom sx={{ color: theme.palette.primary.main }}> {/* Title Color */}
            Our Current Schedule
        </Typography>
      </Box>
      <ProgramShowcase/>
    </Container>
  );
};

export default Programs;
